/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Term_L5Inputs */

const en_mk_term_l5 = /** @type {(inputs: Mk_Term_L5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· Evidence uploaded: 1/2 passed · task complete will be refused`)
};

const id_mk_term_l5 = /** @type {(inputs: Mk_Term_L5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· Bukti diunggah: 1/2 lulus · task complete akan ditolak`)
};

/**
* | output |
* | --- |
* | "· Evidence uploaded: 1/2 passed · task complete will be refused" |
*
* @param {Mk_Term_L5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_term_l5 = /** @type {((inputs?: Mk_Term_L5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Term_L5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_term_l5(inputs)
	return en_mk_term_l5(inputs)
});